/*@flow*/
import type { Node } from 'react';
import LabelLayer, { type OptionsT } from 'lib/leaflet-plugins/LabelLayer';
import React from 'react';
import type { DeckPropsT } from '../types';

export default (props: DeckPropsT<OptionsT>): Node => (
  <LabelLayer map={props.owner} options={props.options} />
);
